<div class="generalPage" aria-label="helpannotations" role="main">
  <div class="pr-22 content-container pb-0 print-all-content" [ngClass]="IsRightPanel?'pt-0':''">
    <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont pb-heading" role="heading">{{pcs_heading}}</h1>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="pc_BodyPreDesc"></p>
    <p *ngIf="Isnotloginpage" class="answer font-16 content-blue width-100 pb-heading">
      <span>{{content1TC}}</span><span class="highlight-blue border-bottom-help cursor-pointer" (click)="showTC()">{{content2TC}}</span><span (click)="openLinkbyId($event)" [innerHTML]="content3TC"></span>
    </p>
    <p *ngIf="!Isnotloginpage" class="answer font-16 content-blue width-100 pb-heading">
      <span (click)="openLinkbyId($event)" [innerHTML]="pc_BodyPreDesc3"></span>
    </p>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="pc_BodyDesc"></p>
  </div>
</div>
